<template>
    <div>
        <querytitle>
            <template slot="queryleft">
                <div>所属区域：</div>
                <div><el-checkbox v-model="chk"></el-checkbox>下级</div>
                <div>
                    <selecttreeview size="mini" v-model="unit" :multiple="false" width="100px" :list="units" :obj="props"></selecttreeview>
                </div>
                <div>审核状态: </div>
                <div>
                    <el-select v-model="f_check" size="mini" style="width:90px;">
                        <el-option v-for="(item) in f_checks" :key="item.FID" :label="item.FVALUE"
                            :value="item.FID"></el-option>
                    </el-select>
                </div>
                <div>年度：</div>
                <div>
                    <el-select v-model="yy" size="mini" style="width:80px;">
                        <el-option v-for="(item) in yys" :key="item" :label="item" :value="item"></el-option>
                    </el-select>
                </div>
                <div>单位等级：</div>
                <div>
                    <el-select v-model="this_level" size="mini" style="width:120px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in levels" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </div>
                <div>单位类型:</div>
                <div>
                    <el-select v-model="this_type" size="mini" style="width:120px;">
                        <el-option label="全部" value=""></el-option>
                        <el-option v-for="(item) in types" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </div>
                <div>申报方式:</div>
                <div>
                    <el-select v-model="checktype" size="mini" style="width:80px;">
                        <el-option v-for="(item) in checktypes" :key="item.FID" :label="item.FVALUE"
                            :value="item.FID"></el-option>
                    </el-select>
                </div>
                <div>模糊条件：</div>
                <div><el-input v-model="keyword" size="mini" style="width:80px;"></el-input> </div>
                <div>
                    <el-button type="primary" size="mini" @click="initdata()">查询</el-button>
                </div>
            </template>
        </querytitle>
        <el-table :data="itemlist" border style="width: 100%" :height="hh" stripe size="mini">
            <el-table-column prop="adv_name" label="单位名称" width="200"></el-table-column>
            <el-table-column prop="checktype" label="申报方式" width="70"></el-table-column>
            <el-table-column prop="this_level" label="单位等级"  width="100"></el-table-column>
            <el-table-column prop="this_type" label="单位类型" width="100"></el-table-column>
            <el-table-column prop="adv_property" label="单位性质" width="70"></el-table-column>

            <el-table-column prop="adv_liabler1" label="行政负责人" width="90"></el-table-column>
            <el-table-column prop="adv_liabler2" label="党组负责人" width="90"></el-table-column>

            <el-table-column prop="adv_address" label="地址"></el-table-column>
            <el-table-column prop="adv_tel" label="联系电话" width="100"></el-table-column>
            <el-table-column prop="adv_email" label="电子邮箱" width="150"></el-table-column>

            <el-table-column prop="adv_state" label="审核状态" width="70"></el-table-column>
            <el-table-column label="操作" width="120" align="center">
                <template slot-scope="scope">
                    <el-link :href="'api/pdfGenerateAdvApplyShow?c_id='+scope.row.c_id" target="_blank"
                        icon="el-icon-view" type="primary" size="mini">查看</el-link>
                    <el-link type="danger" icon="el-icon-finished" size="mini" @click="chkshow(scope)"><span v-if="scope.row.f_check=='待审'">审核</span><span v-else>重审</span></el-link>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination style="text-align:left;" @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="currentpage" :page-sizes="[10, 20, 30, 40,500]" :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper" :total="rt">
        </el-pagination>
        <el-dialog title="文明单位创建申请审批" :visible="dialogFormVisible1" :show-close="false" width="70%">
            <el-descriptions class="margin-top" :column="3" border>
                <el-descriptions-item :span="2">
                    <template slot="label">
                        申报单位
                    </template>
                    {{itemedit.adv_name}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        单位性质
                    </template>
                    {{itemedit.adv_property}}
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">
                        单位地址
                    </template>
                    {{itemedit.adv_address}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        评定届期
                    </template>
                    <el-select v-model="itemedit.last_date" size="mini">
                        <el-option v-for="(item) in yys" :key="item" :label="item"
                            :value="item"></el-option>
                    </el-select>
                    <!-- <el-date-picker v-model="itemedit.last_date" @input="inputmethod()" size="mini">
                    </el-date-picker> -->
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        上次获取等级
                    </template>
                    <el-select v-model="itemedit.last_level" size="mini">
                        <el-option v-for="(item) in levels" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        上次获取类型
                    </template>
                    <el-select v-model="itemedit.last_type" size="mini">
                        <el-option v-for="(item) in types" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        本年申报方式
                    </template>
                    <el-select v-model="itemedit.checktype" size="mini">
                        <el-option v-for="(item) in checktypes" :key="item.FID" :label="item.FVALUE"
                            :value="item.FVALUE"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        本年申报等级
                    </template>
                    <el-select v-model="itemedit.this_level" size="mini">
                        <el-option v-for="(item) in levels" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        本年申报类型
                    </template>
                    <el-select v-model="itemedit.this_type" size="mini">
                        <el-option v-for="(item) in types" :key="item.dict_name" :label="item.dict_name"
                            :value="item.dict_name"></el-option>
                    </el-select>
                </el-descriptions-item>
                <el-descriptions-item :span="2">
                    <template slot="label">
                        <i class="el-icon-tickets"></i>
                        审批方式
                    </template>
                    <el-radio-group v-model="itemedit.f_check">
                        <el-radio label="通过">通过</el-radio>
                        <el-radio label="不通过">不通过</el-radio>
                    </el-radio-group>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        审批日期
                    </template>
                    {{itemedit.f_date}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        审批意见
                    </template>
                    <el-input v-model="itemedit.f_opinion" type="textarea" :rows="6" :maxlength="SYS.len.chkmsglen"></el-input>
                    <div style="color:#c0c0c0;font-size: 10px;float:right;">
                        {{itemedit.f_opinion?itemedit.f_opinion.length:0}}/{{SYS.len.chkmsglen}}
                    </div>
                </el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible1=false">取 消</el-button>
                <el-button type="primary" @click="chkpost()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import querytitle from "../../components/querytitle.vue";
import selecttreeview from "@/components/selecttreeview"
export default {
  components: { querytitle,selecttreeview },
  data(){
      return{
        yys:[],
        yy:'2022',
        itemlist:[],
        rt: 0,
        currentpage: 1,
        pagesize: 20,
        logs:[],
        hh:560,
        checktype:'',
        checktypes:[],
        keyword:'',
        f_check:'待审',
        f_checks:[],
        this_level:'',        
        levels:[],
        //years:[],
        this_type:'',
        types:[],
        dialogFormVisible1:false,
        itemedit:{},
        units:[],
        unit:'',
        chk:true,
        props:{id:'unit_id',label:'unit_name',children:'children',pid:'parent_unit'}
      }
  },
  created() {
    let that = this
    that.hh = document.documentElement.clientHeight - 225;
    this.GetYears(function(res){
        that.yys = res.data
        that.yy = res.yy
        that.getlist();
    });
    that.GETENUM('adv_check','checktype',true,function(res){
        that.checktypes = res
        if (that.checktypes.length > 0) {
          that.checktype = that.checktypes[0].FID;
        }
    })
    that.GETENUM('sys_flowcheck','f_check',true,function(res){
        that.f_checks = res;
    })
    that.GetDict('单位等级',function(res){
        that.levels = res.data
    })
    that.GetDict('单位类型',function(res){
        that.types = res.data
    })
    this.unit = this.CU.cu.orgid;
    that.GetData('SYS/GetUnits',{orgtype:'文明办'},function(res){
        that.units = res.data.data
        that.getlist();
      },function(err){
        that.$alert(err, {title: "错误"});
      })
  },
  methods:{
    initdata(){
        this.currentpage = 1
        this.pagesize = 20
        this.getlist();
    },
    getyears(){
        let that = this
        that.GetData("Years", {},function (res) {
          that.yys = res.data.data
          that.yy = res.data.yy
          that.getlist();
        },function (err) {
          that.$alert(err, {title: "错误"});
        });
    },
    chkshow(par){
        this.addflag = false;
        this.itemindex = par.$index;
        this.itemedit = Object.assign({}, par.row);
        this.itemedit.f_date = this.nowdate()
        if(this.itemedit.last_date.length>4)
            this.itemedit.last_date = this.itemedit.last_date.substring(0,4);
        this.dialogFormVisible1 = true;
    },
    chkpost(){
        let that = this;
        console.log(that.itemedit)
        that.itemedit.last_date = that.FormatDate(that.itemedit.last_date)
        if(that.itemedit.f_check!='通过' && that.itemedit.f_check!='不通过' ){
            that.$alert("请选择审批方式！", {title: "错误",type:'error'});
            return;
        }
        if(that.itemedit.f_check == '不通过' && !that.itemedit.f_opinion){
            that.$alert('请输入审批意见！', { title: "错误" });
            return;
        }
        that.$confirm("确定审核此单位创建申报吗?", "询问", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
        }).then(() => {
            that.PostData("Flow/FLOWGO",that.itemedit,function (res) {
                that.dialogFormVisible1 = false;
                that.getlist()
            },function (err) {
                that.$alert(err, {title: "错误",type: 'error'});
            }
            );
        })
        .catch(() => {});
    },
    getlist(){
      const that = this
      let pars = {
        wheres:[{field: 'b.c_yy',sym: '=',val: this.yy,oper: 'and'},
        {field: 'a.f_unit',sym: '=',val: this.CU.cu.orgid,oper: 'and'}],
        PageSize: that.pagesize,
        CurrentPage: that.currentpage,orders:[{field:'b.c_id',asc:'asc'}]}
    
      if(this.this_level)
        pars.wheres.push({field: 'b.this_level',sym: '=',val: this.this_level,oper: 'and'})
      if(this.this_type)
        pars.wheres.push({field: 'b.this_type',sym: '=',val: this.this_type,oper: 'and'})
      if(this.checktype)
        pars.wheres.push({field: 'b.checktype',sym: '=',val: this.checktype,oper: 'and'})
      if(this.f_check){
        pars.wheres.push({field: 'a.f_check',sym: '=',val: this.f_check,oper: 'and'})
      }
      if(this.keyword){
        pars.wheres.push({field: 'b.adv_name',sym: 'like',val: '%'+this.keyword+'%',oper: 'and'})
      }
      if(this.unit){
          if(this.chk)
            pars.wheres.push({field: 'c.parent_unit',sym: 'like',val: this.unit+'%',oper: 'and'})
          else
            pars.wheres.push({field: 'c.parent_unit',sym: '=',val: this.unit,oper: 'and'})
      }
      that.PostData('Flow/GetCheckAdvanceUnitList', pars, res => {
        that.itemlist = res.data.data
        that.rt = res.data.rowTotal
      }, err => {
        that.$alert(err, {title: "错误"});
      })
    },
    handleCurrentChange(e) {
      this.currentpage = e;
      this.getlist()
    },
    handleSizeChange(e) {
      this.pagesize = e;
      this.getlist()
    },
  }
};
</script>

<style>
</style>